var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarkey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 156.026,
    height: 156.027,
    viewBox: "0 0 156.026 156.027",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "carkey",
    transform: "translate(-133.673 90.479) rotate(-45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_37",
    "data-name": "Pfad 37",
    d: "M-358.824-420.117h-4.166a81.04,81.04,0,0,1-16.017-1.858c-8.8-1.969-15.724-5.281-20.59-9.844-3.525-1.861-4.846-4.95-5.236-12.239h-.147l-.009-6.125c-.015-1.989-.011-4.215-.008-6.368v-.014c0-2.15-.007-4.374.008-6.361l.009-6.132h.147c.39-7.294,1.713-10.384,5.241-12.244,4.64-4.348,11.17-7.567,19.41-9.565A79.982,79.982,0,0,1-364-492.979V-493h5.179a79.436,79.436,0,0,1,15.764,1.688,57.981,57.981,0,0,1,11.187,3.5,35.74,35.74,0,0,1,10.182,6.51c2.491,1.314,3.862,3.307,4.583,6.666.688,3.206.817,7.559.822,14.978,0,.755,0,1.878,0,2.964v.136c.022,15.914.03,21.869-5.4,24.737a35.731,35.731,0,0,1-10.183,6.512,57.974,57.974,0,0,1-11.188,3.5A79.442,79.442,0,0,1-358.824-420.117Zm2.343-62.793h0v52.7a65.191,65.191,0,0,0,16.826-2.6c6.376-1.922,11.145-4.7,13.793-8.023.006-1.407,0-6.714-.005-15.348v-.762c.01-8.606.012-13.915.005-15.352-2.648-3.324-7.417-6.1-13.793-8.021a65.189,65.189,0,0,0-16.826-2.6Zm-9.005,0a65.213,65.213,0,0,0-16.826,2.6c-6.378,1.923-11.147,4.7-13.792,8.021-.006,1.489,0,7.228,0,15.352v.762c-.009,8.087-.011,13.825,0,15.349,2.647,3.326,7.416,6.1,13.792,8.022a65.142,65.142,0,0,0,16.823,2.6Zm22.277,39.141a3.369,3.369,0,0,1-3.276-3.447V-465.6a3.369,3.369,0,0,1,3.276-3.448,3.369,3.369,0,0,1,3.275,3.448v18.386A3.368,3.368,0,0,1-343.21-443.769Zm-36.7,0a3.368,3.368,0,0,1-3.275-3.447V-465.6a3.369,3.369,0,0,1,3.275-3.448,3.369,3.369,0,0,1,3.277,3.448v18.386A3.369,3.369,0,0,1-379.91-443.769Z",
    transform: "translate(548.67 597.429)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_27",
    "data-name": "Pfad 27",
    d: "M172.062,625H143.489c-2.05,0-6.075,2.772-7.475,2.772S129.379,625,127.857,625s-5.5,2.772-7.966,2.772S114.183,625,112.685,625s-5.748,2.772-7.419,2.772S98.968,625,97.452,625c-1.149,0-9.518,7-9.518,9.858v.366h84.128Z",
    transform: "translate(-27 -496.304)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_35",
    "data-name": "Pfad 35",
    d: "M172.062,625H143.489c-2.05,0-6.075,2.772-7.475,2.772S129.379,625,127.857,625s-5.5,2.772-7.966,2.772S114.183,625,112.685,625s-5.748,2.772-7.419,2.772S98.968,625,97.452,625c-1.149,0-9.518,7-9.518,9.858v.366h61.221v3.3h22.411Z",
    transform: "translate(-27 -496.892)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_36",
    "data-name": "Pfad 36",
    d: "M172.062,638.524H143.489c-2.05,0-6.075-2.772-7.475-2.772s-6.636,2.772-8.157,2.772-5.5-2.772-7.966-2.772-5.709,2.772-7.207,2.772-5.748-2.772-7.419-2.772-6.3,2.772-7.813,2.772c-1.149,0-9.518-7-9.518-9.858V628.3h61.221V625h22.411Z",
    transform: "translate(-27 -484.892)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarkey);
export default __webpack_public_path__ + "static/media/carkey.3a67e4cef262da7220329dcdea16ceae.svg";
export { ForwardRef as ReactComponent };